// extracted by mini-css-extract-plugin
export default {"root":"JbisyymL","content":"xueNyBeR","title":"qP0J5BU8","message":"IHnVOZ8f"};